/*
Mixins com funcoes padroes do post editor
*/
import axios from "axios";
import apiMixins from "@/mixins/apiMixins";

export default {
	mixins: [apiMixins],
	methods: {
		createScriptProperty(content) {
			if (content.frameType == "script") {
				content.runCode = true;
			}
			return content;
	    },
		/* 
		atualiza as infos do editor de post com o banco.
		*/
		refreshPostEditorData: async function(siteId, postId) {
			const url = `/site/${siteId}/post/${postId}/edit`;
            let post = await this.requestApiData(url, "get");
            if (post.status == 1) {
	            this.postType = post.data.type;
				
				if (!post.data.content[0]) {
					alert('Erro ao validar os dados do post. Caso o erro persista, entre em contato com nosso atendimento!');
					this.$router.back();
				}

	            if (post.data.content[0].component.indexOf("home") > -1) {
	              this.postType = "home";
	            }
	            //post.data.content = post.data.content.map(this.createScriptProperty());

	            this.$store.dispatch("dashboardModule/getPostData", [post.data]);
	            return post
	        } else return false
		},
		//Faz request para criar um novo MainContant
	    requestNewCardPost: async function (siteId, postId, index = false) {
	    	if (!index) { 
	    		index = 0
	    	}

			let data = { index: index };
			const url = `/site/${siteId}/post/${postId}/card`;

			const responseApi = await this.requestApiData(url, "post", data);
			console.log('responseApi', responseApi)
			return responseApi;
	    }
	}

}



// WEBPACK FOOTER //
// ./src/mixins/postMixins.js